import { render, staticRenderFns } from "./shopfrom.vue?vue&type=template&id=81be3b6e&scoped=true&"
import script from "./shopfrom.vue?vue&type=script&lang=js&"
export * from "./shopfrom.vue?vue&type=script&lang=js&"
import style0 from "./shopfrom.vue?vue&type=style&index=0&id=81be3b6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81be3b6e",
  null
  
)

export default component.exports